import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: item.key
    }, [
      (item.group && item.group !== _ctx.items[i - 1]?.group)
        ? (_openBlock(), _createBlock(_component_v_list_subheader, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.group), 1)
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true),
      _createVNode(_component_v_list_item, {
        to: item.to,
        title: item.title
      }, null, 8, ["to", "title"])
    ], 64))
  }), 128))
}